;
define("requestquote_accesspoints_headerlink.tpl", function(){});

